import React from 'react';
// import Header from '../Partial/header/header';
import Footer from '../Partial/footer/footer';
import Navbar from '../Partial/navbar/Navbar';
import CoverBackground from './coverBackground';
import DealsShow from './dealsShow';
import NewDealAdmin from '../AdminRoute/newDealAD';

export default function dealsList(){
    return(
        <div>
            {/* <Header/> */}
            <Navbar/>
            <CoverBackground/>
            <NewDealAdmin/>
            <DealsShow/>
            <Footer/>
        </div>
    )
    
}